// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_form_container__rfBWA{
    width: 100%;
}

.styles_container_button__6epPQ{
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .styles_button_next__jur3A {
    background-color: #18316e !important;
    color: #ffffff !important;
    font-family: "Inter" !important;
    font-weight: 400 !important;
    padding: .4rem 1.5rem !important;
    text-transform: none !important;
    transition: all 0.3s ease !important;
  }
  
  .styles_button_next__jur3A:hover {
    transform: scale(0.95) !important;
    opacity: 0.9;
  }

  .styles_button_back__2CawA {
    background-color: #fff !important;
    border: 1px solid #18316e !important;
    color: #18316e !important;
    font-family: "Inter" !important;
    font-weight: 400 !important;
    padding: .4rem 1.5rem !important;
    text-transform: none !important;
    transition: all 0.3s ease !important;
  }
  
  .styles_button_back__2CawA:hover {
    transform: scale(0.95) !important;
    opacity: 0.9;
  }`, "",{"version":3,"sources":["webpack://./src/components/CadastroDetalhado/DadosBancarios/styles.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,+BAA+B;IAC/B,2BAA2B;IAC3B,gCAAgC;IAChC,+BAA+B;IAC/B,oCAAoC;EACtC;;EAEA;IACE,iCAAiC;IACjC,YAAY;EACd;;EAEA;IACE,iCAAiC;IACjC,oCAAoC;IACpC,yBAAyB;IACzB,+BAA+B;IAC/B,2BAA2B;IAC3B,gCAAgC;IAChC,+BAA+B;IAC/B,oCAAoC;EACtC;;EAEA;IACE,iCAAiC;IACjC,YAAY;EACd","sourcesContent":[".form_container{\n    width: 100%;\n}\n\n.container_button{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .button_next {\n    background-color: #18316e !important;\n    color: #ffffff !important;\n    font-family: \"Inter\" !important;\n    font-weight: 400 !important;\n    padding: .4rem 1.5rem !important;\n    text-transform: none !important;\n    transition: all 0.3s ease !important;\n  }\n  \n  .button_next:hover {\n    transform: scale(0.95) !important;\n    opacity: 0.9;\n  }\n\n  .button_back {\n    background-color: #fff !important;\n    border: 1px solid #18316e !important;\n    color: #18316e !important;\n    font-family: \"Inter\" !important;\n    font-weight: 400 !important;\n    padding: .4rem 1.5rem !important;\n    text-transform: none !important;\n    transition: all 0.3s ease !important;\n  }\n  \n  .button_back:hover {\n    transform: scale(0.95) !important;\n    opacity: 0.9;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form_container": `styles_form_container__rfBWA`,
	"container_button": `styles_container_button__6epPQ`,
	"button_next": `styles_button_next__jur3A`,
	"button_back": `styles_button_back__2CawA`
};
export default ___CSS_LOADER_EXPORT___;
